export default {
  HIDE_POPUP: "realityCheck/HIDE_POPUP",
  SHOW_POPUP: "realityCheck/SHOW_POPUP",
  SET_SPORT_SESSION_DETAILS: "realityCheck/SET_SPORT_SESSION_DETAILS"
};
